.icon {
    display: none;
    @container (min-width: $mantine-breakpoint-sm) {
        display: block;
    }
}

.root {
    /* display: flex; */
    padding: var(--mantine-spacing-md);
    @container (min-width: $mantine-breakpoint-sm) {
        padding: var(--mantine-spacing-md);
    }
    width: 100%;
    &:hover {
        .hidden {
            opacity: 1;
        }
    }

    color: black;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: var(--mantine-spacing-md) 0;
        color: black;
    }

    h2 {
        font-size: var(--mantine-font-size-xl);
    }

    strong,
    b {
        color: black;
    }

    ol,
    ul {
        margin: var(--mantine-spacing-md) 0;
        padding-left: var(--mantine-spacing-md);

        @container (min-width: $mantine-breakpoint-sm) {
            padding-left: calc(
                var(--mantine-spacing-lg) + var(--mantine-spacing-md)
            );
            margin: var(--mantine-spacing-md) 0;
        }
    }
}

.group {
    @container (min-width: $mantine-breakpoint-sm) {
        padding-right: calc(
            var(--mantine-spacing-xl) + var(--mantine-spacing-sm)
        );
    }
}

.centered {
    width: 48rem;
    margin: 0 auto;
}

.container {
    flex: 1;
    min-width: 0;
}

.content {
    /* padding: var(--mantine-spacing-xs) 0; */
    & :first-child {
        margin-top: 0;
    }
    & :last-child {
        margin-bottom: 0;
    }
    font-size: var(--mantine-font-size-sm);
    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-md);
    }
}

.hidden {
    opacity: 0;
    transition: opacity 0.1s;
}

.thinkingGradient {
    display: inline-block;
    line-height: 1.5;
    @container (min-width: $mantine-breakpoint-sm) {
        line-height: 2;
    }
}
